import { Component } from '@angular/core';

@Component({
  selector: 'app-ui-avatar',
  templateUrl: './ui-avatar.component.html',
  styleUrls: ['./ui-avatar.component.css']
})
export class UiAvatarComponent {
  /**
   * Header button list show
   */
  Settingicon = true;
  Menuoption = 'center'
}
